import AlertModal from './alert-modal';

export default AlertModal;
